export default "__VITE_ASSET__EtZq0Vtu__"